import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Avatar,
  IconButton,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  ListItemSecondaryAction,
  Chip,
} from '@material-ui/core';

import AddComment from '@material-ui/icons/AddComment';
import CancelIcon from '@material-ui/icons/Cancel';
import ClearIcon from '@material-ui/icons/Clear';

import ModalServiciosSugeridos from '../ModalServiciosSugeridos';

import './styles.css';

import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 5,
    border: '2px solid #f44336d1',
  },
  avatarBlue: {
    // backgroundColor: '#01579b',
    border: '1 solid #01579b',
    color: '#01579b',
  },

  buttons: {
    justifyContent: 'right',
  },
  colorRed: {
    color: '#F44336',
  },
  tachado: {
    textDecoration: 'line-through',
    backgroundColor: '#f44336d1',
  },
  trenCancelado: {
    width: '100%',
    height: '100%',
    textAlign: 'center',
    backgroundColor: '#f44336d1',
    padding: '2px',
    color: 'white',
    fontWeight: 'bold',
  },
  avatarCancelado: {
    backgroundColor: '#f44336d1',
  },
}));

export default function RecipeReviewCard({ reserva }) {
  const classes = useStyles();

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  return (
    <>
      {reserva.serviciosSugeridos && (
        <ModalServiciosSugeridos
          open={open}
          setOpen={setOpen}
          reserva={reserva}
        ></ModalServiciosSugeridos>
      )}
      <Card className={classes.root} id=''>
        <CardHeader
          avatar={
            <Avatar aria-label='recipe' className={classes.avatarCancelado}>
              <CancelIcon />
            </Avatar>
          }
          title={
            reserva.servicio.tipo.nombre.toUpperCase() +
            ' ' +
            reserva.servicio.numero +
            ' ( cancelado )'
          }
          subheader={`${moment(reserva.servicio.desde.fecha).format('DD/MM/YYYY')} - ${
            reserva.cantidad
          } ${reserva.cantidad === 1 ? 'Pasajero' : 'Pasajeros'}`}
          action={
            reserva.serviciosSugeridos && (
              <IconButton
                aria-label='copiar'
                // color='secondary'
                onClick={() => handleClickOpen()}
                title='Ver viajes Sugeridos'
                className={classes.avatarBlue + ' pulse'}
              >
                <AddComment />
              </IconButton>
            )
          }
        />
        <CardContent>
          <List component='nav' aria-label='main mailbox folders'>
            <ListItem>
              <ListItemIcon>
                <ClearIcon className={classes.colorRed} />
              </ListItemIcon>
              <ListItemText primary={reserva.servicio.desde.nombre.toUpperCase()} />
              <ListItemSecondaryAction>
                <IconButton edge='end' aria-label='comments'>
                  <Chip
                    size='small'
                    label={moment(reserva.servicio.desde.fecha).format('HH:mm')}
                    className={classes.tachado}
                  ></Chip>
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
            <Divider className={classes.avatarCancelado} />
            <ListItem>
              <ListItemIcon>
                <ClearIcon className={classes.colorRed} />
              </ListItemIcon>
              <ListItemText primary={reserva.servicio.hasta.nombre.toUpperCase()} />
              <ListItemSecondaryAction>
                <IconButton edge='end' aria-label='comments'>
                  <Chip
                    size='small'
                    label={moment(reserva.servicio.hasta.fecha).format('HH:mm')}
                    className={classes.tachado}
                  ></Chip>
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          </List>
        </CardContent>
        <CardActions disableSpacing className={classes.buttons}>
          <div className={classes.trenCancelado}>TREN CANCELADO</div>
        </CardActions>
      </Card>
    </>
  );
}
